(function () {
	'use strict';

	angular
		.module('invesfleet')
		.factory('puntoInteresService', puntoInteresService);

	puntoInteresService.$inject = ['$http', '$q', 'endPoints', 'authorization'];

	function puntoInteresService($http, $q, endPoints, authorization) {
		var service = {
			getList: getList,
		};

		return service;


		function getList(sorting, filters) {
			var deferred = $q.defer();
			var request = {
				method: 'POST',
				url: endPoints.puntosInteres.getAll
			};
			authorization.setBearerHeader($http);
			$http(request).then(function (response) {
				deferred.resolve(response);
			},
				function (response) {
					deferred.reject(null);
				});
			return deferred.promise;
		}

	}

})();